import React, { useContext } from "react";
import { Checkbox, FilterBar, IconButton, InputAdornment, List, Menu, SearchBar, Select, } from "@sscs/ui";
import { CloseIcon } from "@sscs/ui/icons";
import { capitalizeFirstLetter } from "@sscs/utils";
import { produce } from "immer";
import { initFilter, selectFilteredByLink } from "../../../../store/sbomSlice";
import { CommonListFilter, LicenseFamilyFilter, VerifiedFilter, } from "../../../common";
import { ReportContext } from "../../../context";
import { useReportSelector } from "../../../hooks";
import { useLazyGetSoftwarePublishersQuery } from "../../../services/sbom.api";
import { DEPENDENCY_LINKING_TO_LONG_TEXT, isFilteredByLink, } from "../../../utils";
import styles from "./filter.module.scss";
const Filter = ({ filter, onFilterChange }) => {
    var _a;
    const filteredByLink = useReportSelector(selectFilteredByLink);
    const { reportId } = useContext(ReportContext);
    const [trigger, { isFetching, data: publishers }] = useLazyGetSoftwarePublishersQuery();
    const handleSearchChange = (value) => {
        const productOrFileName = value === "" ? null : value;
        /* Update debounced filter only when not set via redux action
         *
         * Updating when set via action will cause component id to be reset
         * and multiple components endpoint will be queried instead of specific item endpoint */
        if (filter.product_or_file_name !== productOrFileName) {
            onFilterChange(produce(filter, (draftState) => {
                draftState.product_or_file_name = productOrFileName;
            }));
        }
    };
    return (React.createElement(FilterBar, { filters: [
            {
                id: "name",
                row: 1,
                control: (React.createElement(SearchBar, { id: "sbom-name-search", value: (_a = filter.product_or_file_name) !== null && _a !== void 0 ? _a : "", onChange: handleSearchChange, label: "Regex search for product name or file name", className: styles["name-filter"], slotProps: { htmlInput: { maxLength: 256 } }, "data-filtered-by-link": isFilteredByLink(filter, initFilter, "product_or_file_name", filteredByLink) })),
            },
            {
                id: "verified",
                row: 2,
                control: (React.createElement(VerifiedFilter, { id: "sbom-verified-filter", allItemsLabel: "Show all software", value: filter.verified_matches, onChange: (value) => onFilterChange(produce(filter, (draftState) => {
                        draftState.verified_matches = value;
                    })), onClear: () => onFilterChange(produce(filter, (draftState) => {
                        draftState.verified_matches = initFilter.verified_matches;
                    })) })),
            },
            {
                id: "publisher",
                row: 2,
                control: (React.createElement(CommonListFilter, { id: "sbom-filter-publishers", value: filter.publisher, options: publishers, filterName: "Publisher", onOpen: () => trigger({ ui_id: reportId }), loading: isFetching, onChange: (event, value) => {
                        onFilterChange(produce(filter, (draftState) => {
                            draftState.publisher = value;
                        }));
                    } })),
            },
            {
                id: "license",
                row: 2,
                control: (React.createElement(LicenseFamilyFilter, { id: "sbom-filter-licenses", value: filter.license_family, onChange: (value) => onFilterChange(produce(filter, (draftState) => {
                        draftState.license_family = value;
                    })) })),
            },
            {
                id: "software-type",
                row: 2,
                /*TODO: Consider integrating multiselect dropdown into DropdownMenu since it keeps repeating */
                control: (React.createElement(Select, { label: "Filter by software type", id: "sbom-software-type-filter", labelId: "sbom-software-type-filter-label", multiple: true, displayEmpty: true, shrinkLabel: true, value: filter.software_type, renderValue: (value) => {
                        if (Array.isArray(value)) {
                            if (value.length === 0) {
                                return "Show all software types";
                            }
                            return value
                                .map((item) => capitalizeFirstLetter(item))
                                .join(", ");
                        }
                        else {
                            return undefined;
                        }
                    }, onChange: (value) => {
                        onFilterChange(produce(filter, (draftState) => {
                            draftState.software_type =
                                value;
                        }));
                    }, endAdornment: filter.software_type.length > 0 ? (React.createElement(InputAdornment, { position: "end" },
                        React.createElement(IconButton, { className: styles["close-icon"], size: "small", onClick: () => onFilterChange(produce(filter, (draftState) => {
                                draftState.software_type = initFilter.software_type;
                            })) },
                            React.createElement(CloseIcon, null)))) : undefined, classes: { select: styles.select } },
                    React.createElement(Menu.Item, { id: "filter-by-components", value: "component" },
                        React.createElement(Checkbox, { checked: filter.software_type.includes("component") }),
                        React.createElement(List.ItemText, { primary: "Component" })),
                    React.createElement(Menu.Item, { id: "filter-by-dynamic", value: "dynamic" },
                        React.createElement(Checkbox, { checked: filter.software_type.includes("dynamic") }),
                        React.createElement(List.ItemText, { primary: DEPENDENCY_LINKING_TO_LONG_TEXT.dynamic })),
                    React.createElement(Menu.Item, { id: "filter-by-static", value: "static" },
                        React.createElement(Checkbox, { checked: filter.software_type.includes("static") }),
                        React.createElement(List.ItemText, { primary: DEPENDENCY_LINKING_TO_LONG_TEXT.static })),
                    React.createElement(Menu.Item, { id: "filter-by-package-release", value: "release" },
                        React.createElement(Checkbox, { checked: filter.software_type.includes("release") }),
                        React.createElement(List.ItemText, { primary: `Release ${DEPENDENCY_LINKING_TO_LONG_TEXT.package}` })),
                    React.createElement(Menu.Item, { id: "filter-by-package-develop", value: "develop" },
                        React.createElement(Checkbox, { checked: filter.software_type.includes("develop") }),
                        React.createElement(List.ItemText, { primary: `Develop ${DEPENDENCY_LINKING_TO_LONG_TEXT.package}` })))),
            },
        ] }));
};
export default Filter;
//# sourceMappingURL=Filter.js.map